<script>
    import Reveal from '../../mixins/Reveal.vue';
    export default {
        mixins: [Reveal],
        mounted() {
            window.EventHandler.listen('toggle-reveal', this.handle);
        },
        methods: {
            handle(name) {
                if (name.toString() !== this.name) {
                    return;
                }
                this.visible = !this.visible;
            }
        }
    };
</script>